module.exports = __webpack_public_path__ + "img/mu.f5cbb509.svg";